import React from "react";

import "./src/styles/fonts/TrueNorthRough/font-face.scss";
import "./src/styles/fonts/Avenir/styles.css";
import "react-18-image-lightbox/style.css";
import "./src/styles/bootstrap/index.scss";
import "./src/styles/default.scss";

export const wrapRootElement = ({ element }) => <>{element}</>;
